import { useFormContext } from "react-hook-form";
import { InputMask } from "@/components/fields/mask-input";
import type { MaskInputProps, MaskPreset } from "@/components/fields/mask-input/types";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

interface FormInputMaskProps extends Omit<MaskInputProps, "onChange" | "value"> {
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  preset: MaskPreset;
}

export function FormInputMask({
  name,
  label,
  required,
  disabled,
  preset,
  ...props
}: FormInputMaskProps) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={function renderMaskField({ field }) {
        return (
          <FormItem>
            {label && <FormLabel required={required}>{label}</FormLabel>}
            <FormControl>
              <InputMask
                {...props}
                preset={preset}
                value={field.value ?? ""}
                onChange={field.onChange}
                disabled={disabled}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
}
